// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3cRpY","container":"styles_container__2r0Qv","title":"styles_title__2qydH","wrapper":"styles_wrapper__2hnho","answer":"styles_answer__1mhGB"};